import { render, staticRenderFns } from "./VaccinationListCard.vue?vue&type=template&id=6dea3be0&scoped=true&"
import script from "./VaccinationListCard.vue?vue&type=script&lang=js&"
export * from "./VaccinationListCard.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationListCard.vue?vue&type=style&index=0&id=6dea3be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea3be0",
  null
  
)

export default component.exports